import { formatIconImg, formatImgCash, formatTags } from './formatters';
import { formatTableAttr } from './formatters/attributes';
import { RPGLink, RPGTypes, TableFlags2 } from './formatters/types';
import type { Options, PokerGameTile, ScheduledTableType, TableType } from './types';
import { ePoolBlockGameTypeCollection } from './types';

const mapTableType = (
  {
    id,
    clubId,
    cap,
    ante,
    currency,
    minChipsLimit,
    game,
    isHiLo,
    maxBuyIn,
    maxPlayers,
    server,
    serverObj,
    structure,
    tableStakes: { blinds, stakes },
    lastEntry,
    tableFlags2,
    isPlayMoney,
    scalePM,
    loBet,
    hiBet
  }: TableType,
  { language }: Options
) => ({
  id,
  clubId,
  type: RPGTypes.CASH_GAME,
  link: RPGLink.TABLE,
  imageUrl: formatImgCash(game, structure, maxBuyIn, cap, isHiLo, tableFlags2),
  imageUrlV2: formatImgCash(game, structure, maxBuyIn, cap, isHiLo, tableFlags2, true),
  tags: formatTags({
    game,
    structure,
    maxPerTable: maxPlayers,
    ante,
    cap,
    tableFlags2,
    isHiLo: Boolean(isHiLo)
  }),
  attributes: formatTableAttr(
    {
      minChipsLimit,
      maxBuyIn,
      blinds: blinds?.map((blind) => Number(blind)) ?? [],
      currency,
      ante,
      flags2: tableFlags2,
      game,
      stakes: stakes?.map((stake) => Number(stake)) ?? [],
      isPlayMoney,
      structure,
      scalePM,
      loBet,
      hiBet
    },
    language
  ),
  lastEntry,
  iconUrl: formatIconImg(RPGTypes.CASH_GAME),
  server,
  serverObj,
  ePoolBlockGameType: ePoolBlockGameTypeCollection.tableType,
  isPlayMoney: Boolean(isPlayMoney), // isPlayMoney could be a number (0/1),
  // tableFlags2 should be parsed to string from Middle Tiers and then we can use is64BitFlagSet
  // eslint-disable-next-line no-bitwise
  hasVideoSupport: !!(tableFlags2 & TableFlags2.TABLESCRIPT_FLAG2_VIDEO_CHAT)
});

const mapTableTypesFn = (tableTypes: ScheduledTableType[], options: Options): PokerGameTile[] =>
  // @ts-ignore TODO: Refactor mappers -> 'ScheduledTableType' is not assignable to parameter of type 'TableType', which is DeepNonNullable<ScheduledTableType> & { id: string; serverObj: string; lastEntry: string; }
  tableTypes.map((type) => mapTableType(type, options));

export default mapTableTypesFn;
